import { useLoggedOutSuppliersBrandsSearchRequestContext } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/BrandsSearchContext/LoggedOutSuppliersBrandsSearchRequestContext";
import { useLoggedOutSuppliersPageBrandSearchResults } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageBrandSearchResults";
import { useLoggedOutSuppliersPageDataUpdatedAt } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageDataUpdatedAt";
import { useLoggedOutSuppliersPageIsError } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsError";
import { useLoggedOutSuppliersPageIsPending } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { PerformanceMarkStartTime } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";

export const useLoggedOutSuppliersPageUPLT = (
  pageJsExecutedMark: PerformanceMarkStartTime | undefined
) => {
  const isPending = useLoggedOutSuppliersPageIsPending();
  const brandSearchResults = useLoggedOutSuppliersPageBrandSearchResults();
  const isError = useLoggedOutSuppliersPageIsError();

  const isLoadedAndHasNoResults =
    !isPending && brandSearchResults && brandSearchResults.length === 0;

  const { requestKey } = useLoggedOutSuppliersBrandsSearchRequestContext();
  const dataUpdatedAt = useLoggedOutSuppliersPageDataUpdatedAt();

  const loadTimingRef = useUserPerceivedLoadTimingWithKey({
    name: "page-suppliers",
    pageLoadKey: JSON.stringify(requestKey),
    dataUpdatedAt,
    numComponents: 1,
    ignoreImages: isLoadedAndHasNoResults || isError,
    isPageLoading: isPending,
    pageJsExecutedMark,
    enableTrackPerformanceBreakdown: "internal-tracking",
  });
  return loadTimingRef;
};
